import { Box, Typography, LinearProgress } from '@mui/material';

import React, { useState } from 'react';
import __t from "../../../lib/traduzioni";
import { useInterval } from 'react-use';
import {addSeconds, differenceInSeconds, endOfDay, format} from 'date-fns'
import { convertToDuration, humanDuration } from '../../../lib/dateshelper';
import useBSSLogger from '../../../hooks/useBSSLogger'
const {logger} = useBSSLogger()


/**
 * Dato un preventivo renderizza il countdown per il ritiro in giornata
 * il primo controllo viene effettuato dopo delayPrimoControllo millisecondi
 * sopra sogliaBreve secondi il controllo viene effettuato ogni intervalloLungo 
 * sotto sogliaBreve secondi il controllo viene effettuato ogni intervalloBreve
 * Se il componente riceve un elemento figlio lo renderizza in caso di timer scaduto (es. <CountDown...>timer scaduto!</CountDown...>)
 * 
 * @param {{preventivo: ResPreventivo, sogliaBreve: Number, intervalloLungo: Number, intervalloBreve: Number, delayPrimoControllo: Number}} param0 
 * @returns 
 */
const CountDownRitiroInGiornata = ({preventivo, sogliaBreve = 60*90, intervalloLungo = 60000, intervalloBreve = 1000, delayPrimoControllo = 200, children}) => {
    const [timer, setTimer] = useState({counter: 0})

    let pulisci = false;

    /**
     * Timer per ritiri in giornata, attualmente si basa su pickupdate
     */
    useInterval(() => {


        const inizio = timer?.inizio ?? new Date();
        const istante = new Date();
        const scadenza = addSeconds(preventivo.pickupdate, 0);                
        const secondidisponibili = differenceInSeconds(scadenza, istante);
        const finegiornata = endOfDay(istante);
        const scadenzaingiornata = differenceInSeconds(scadenza, finegiornata) <= 0;
        const stoppa = secondidisponibili <= 0 || !scadenzaingiornata;            
        const progresso = differenceInSeconds(istante, inizio);
        const tempototale = differenceInSeconds(scadenza, inizio);
        const percentuale = (progresso / tempototale) * 100;
        const label = convertToDuration(secondidisponibili);
        const humanlabel = humanDuration(secondidisponibili);
        const counter = timer.counter + 1
        const nextRefresh = stoppa ? null : intervalloBreve // (counter === 0) ? delayPrimoControllo : (secondidisponibili > sogliaBreve) ? intervalloLungo : intervalloBreve
        const labelOre = format(scadenza, "HH:mm:ss");

        logger.finest(`per il prodotto ${preventivo.product} il ritiro in giornata è disponbile per ${secondidisponibili} (${percentuale}%) secondi, prossimo controllo tra ${nextRefresh} secondi ${stoppa && 'stoppo il conto alla rovescia'}`)


        setTimer({
            counter,
            inizio,
            secondidisponibili,
            percentuale,
            stoppa,
            label,
            humanlabel,
            labelOre,
            nextRefresh
        })


    }, timer.nextRefresh)
        

    return !(timer?.stoppa ?? true) ? (
        <Box alignItems="center">
            <Box width={1} textAlign="right">
                <Typography variant="body2" color="textSecondary">
                    {__t("ritiroingiornataentro")}:
                    <b>                                                        
                        {" "}
                        {timer?.humanlabel ?? ""}
                        {/* {(timer?.secondidisponibili ?? 0) > sogliaBreve ? (timer?.labelOre ?? "") : (timer?.label ?? "")} */}
                    </b>
                </Typography>
            </Box>
            <Box width={1}>
                <LinearProgress variant="determinate" value={timer?.percentuale ?? 0} />
            </Box>
            
        </Box>     
    ) : (
        <>
            {children}
        </>
    )
}

export default CountDownRitiroInGiornata;